var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0358 11.7122V15.2122C14.0358 18.1289 12.8691 19.2956 9.95247 19.2956H6.45247C3.53581 19.2956 2.36914 18.1289 2.36914 15.2122V11.7122C2.36914 8.79557 3.53581 7.62891 6.45247 7.62891H9.95247C12.8691 7.62891 14.0358 8.79557 14.0358 11.7122Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0358 6.71224V10.2122C19.0358 13.1289 17.8691 14.2956 14.9525 14.2956H14.0358V11.7122C14.0358 8.79557 12.8691 7.62891 9.95247 7.62891H7.36914V6.71224C7.36914 3.79557 8.53581 2.62891 11.4525 2.62891H14.9525C17.8691 2.62891 19.0358 3.79557 19.0358 6.71224Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.8cc5ed18bcd9ebf8489c021ff01b6f85.svg";
export { ForwardRef as ReactComponent };